import CourseController from '../../../../../components/diagrams/course.controller';
import exercise1 from './i18n/exercise1';
import exercise2 from './i18n/exercise2';
import exercise3 from './i18n/exercise3';
import exercise4 from './i18n/exercise4';
import exercise5 from './i18n/exercise5';
import exercise6 from './i18n/exercise6';
import exercise7 from './i18n/exercise7';
import exercise8 from './i18n/exercise8';

class PracticeDefiningProblem2Controller extends CourseController {

  constructor(courseService, helperService, $sce, $scope) {
    "ngInject";
    super(courseService, helperService, $sce, $scope);
    Object.assign(this, { helperService, $sce });
    this.videoUrl = this.$sce.trustAsResourceUrl('https://player.vimeo.com/video/325082707');
    // this.helperService.initIntercom();
    this.lang = 'en';
    this.exercise1 = exercise1[this.lang];
    this.exercise2 = exercise2[this.lang];
    this.exercise3 = exercise3[this.lang];
    this.exercise4 = exercise4[this.lang];
    this.exercise5 = exercise5[this.lang];
    this.exercise6 = exercise6[this.lang];
    this.exercise7 = exercise7[this.lang];
    this.exercise8 = exercise8[this.lang];
    this.isUnit = true
    this.isUnitFive = true
    this.exerciseUserAnswers = {}
  }

  onSubmitScqDiagramDndFramework(nextExercise, nextExerciseLink, pyramidData) {
    if ((this.isCompleted['1'] && nextExercise === 'exercise1-2') || (nextExercise === 'exercise2-2' && this.isCompleted['2']) || (nextExercise === 'exercise3-2' && this.isCompleted['3']) || (nextExercise === 'exercise4-2' && this.isCompleted['4'])) {
      return
    }
    this.complexExercises[pyramidData.exerciseNumber] = _.cloneDeep(pyramidData.model)
    super.onSubmitScqDiagramDndFramework(nextExercise, nextExerciseLink, pyramidData)
  }

  onClosePyramidBuilder(event) {
    if (!this.isActivePyramidBuilderDemo) return;
    const userAnswer = event.store[event.key].scq
    if (this.nextExercise === 'exercise8' && !this.isCompleted['4']) {
      this.complexExercises['4'].pyramidBuilderAnswer = userAnswer
    } else {
      this.onFinishExercise(this.nextExercise === 'exercise2' && !this.isCompleted['1']
        ? '1'
        : this.nextExercise === 'exercise4' && !this.isCompleted['2']
          ? '2'
          : this.nextExercise === 'exercise6' && !this.isCompleted['3']
            ? '3'
            : '0',
        userAnswer)
    }
    super.onClosePyramidBuilder(event)
  }
}

export default PracticeDefiningProblem2Controller;



// WEBPACK FOOTER //
// ./client/app/modules/courses/5/5c/practiceDefiningProblem2/practiceDefiningProblem2.controller.js